export function mapErrorToErrorMessage(error: any): string | undefined {
	if (!error) {
		return undefined;
	}
	if (error?.message && typeof error.message === 'string') {
		return error.message;
	}
	if (error?.errors && typeof error.errors === 'object') {
		const firstError = Object.values(error.errors)[0];
		if (Array.isArray(firstError) && firstError.length > 0) {
			return firstError[0];
		}
	}
	if (error?.title && typeof error.title === 'string') {
		return error.title;
	}
	return undefined;
}
